import _ from 'lodash';

import { GOODIES } from '../constants';

function getNewGoody(collectedPets, collectedGoodies) {
	// Get the types of collected pets.
	const typesOfPets = _
		.chain(collectedPets)
		.map('type')
		.uniq()
		.value();

	// Get array of all new goodies that we can get with these types of pets.
	const newGoodiesForTypesOfPets = _.filter(GOODIES, (goody) => {
		const isForThesePetTypes = _.isUndefined(goody.forPetType) || _.includes(typesOfPets, goody.forPetType);
		const isNotCollected = !_.includes(collectedGoodies, goody.id);

		return isForThesePetTypes && isNotCollected;
	});

	// Return a random new goody.
	return newGoodiesForTypesOfPets[_.random(newGoodiesForTypesOfPets.length - 1)];
}

export default getNewGoody;



// WEBPACK FOOTER //
// ./src/utils/getNewGoody.js